import PropTypes from 'prop-types'
import Slider from 'react-slick'
import React, { useEffect, useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardMedia from '@material-ui/core/CardMedia'
import CardContent from '@material-ui/core/CardContent'
import LinesEllipsis from 'react-lines-ellipsis'
import Link from '@components/link'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import useStyles, { ArticleCard } from './articles-slider.styles'

const ArticlesSlider = (props) => {
  const {
    articles,
  } = props
  const styles = useStyles()
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  const summaryMaxLines = isMobile ? 3 : 2

  const NextArrowButton = (prps) => {
    const { onClick } = prps
    return (
      <IconButton
        aria-label="next"
        className={`${styles.iconButton} ${styles.iconNext}`}
        onClick={onClick}
      >
        <ArrowForwardIosIcon
          className={styles.icons}
          fontSize="small"
        />
      </IconButton>
    )
  }

  const PrevArrowButton = (prps) => {
    const { onClick } = prps
    return (
      <IconButton
        aria-label="previous"
        className={`${styles.iconButton} ${styles.iconPrev}`}
        onClick={onClick}
      >
        <ArrowBackIosIcon
          className={styles.icons}
          fontSize="small"
        />
      </IconButton>
    )
  }

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <NextArrowButton />,
    prevArrow: <PrevArrowButton />,
    responsive: isClient ? [
      {
        breakpoint: 960,
        settings: {
          infinite: false,
          slidesToShow: 1.1,
          swipeToSlide: true,
        },
      },
    ] : null,
  }

  return (
    <Box mb={[10, 10, 0]} pl={2} pr={[0, 0, 2]}>
      <Slider
        key={`coach-articles-slider-${isClient ? 'client' : 'server'}`}
        {...settings}
        className={styles.articleWrapper}
      >
        {articles.map(article => (
          <Link {...article} key={article.headline}>
            <ArticleCard>
              <CardActionArea>
                <CardMedia
                  component="img"
                  alt={article.headline}
                  image={`${article.image.url}?w=1280&fit=fill`}
                  title={article.headline}
                />
                <CardContent className={styles.cardContent}>
                  <Typography variant="h5" gutterBottom>
                    {article.headline}
                  </Typography>
                  <LinesEllipsis
                    maxLine={summaryMaxLines}
                    text={article.summary || ''}
                    className={styles.summary}
                  />
                </CardContent>
              </CardActionArea>
            </ArticleCard>
          </Link>
        ))}
      </Slider>
    </Box>
  )
}

ArticlesSlider.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.object),
}

export default ArticlesSlider
